import React, { useState, useEffect } from 'react'
import axios from 'axios'


import Loader from '../../Loader/Loader';
import ProjectCard from './ProjectCard/ProjectCard'


import './Projects.css'

const PROJECT_URL = "/projects"

function Projects() {

  const [projects, setProjects] = useState('')

  useEffect(() => {
    async function getProjects() {
      try {
        const response = await axios.get(process.env.REACT_APP_DEPT_API + PROJECT_URL);
        setProjects(response.data);
      } catch (error) {
        console.error(error);
      }
    }
    getProjects()
  }, [])


  return (
    <div className='projects'>
      <div className='section__container'>
        <div className='section'>
          <h1 className='section__header'>Projects</h1>
          <p className='about__p'>
            The Department has produced diverse projects adroit in this technological era which helps in moulding and structuring capable engineers and  forms a pioneering step for the future. These projects help  inculcate the students with the latest advancements in the industry and stay updated with the new digital era. It is a critical catalyst to drive innovation and boost employment.
          </p>
          <div className='project_container'>
            {projects ? projects.map((proj) => (
              <ProjectCard
                key={proj._id}
                id={proj._id}
                title={proj.title}
                description={proj.description}
                domain={proj.domain}
                link={proj.link}
                team_lead_batch={proj.team_lead_batch}
                team_lead_name={proj.team_lead_name}
                team_members={proj.team_members}
                tech_stack={proj.tech_stack}
              />
            )) : <Loader color="#AE9142" size={70} />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Projects